// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { GroupSecurity } from '@quromedical/fhir-common';
import type {
  DeviceAssociationGetAllResponse,
  DeviceAssociationTable,
} from '@quromedical/models';
import { PaginatedTable } from 'core/table';
import type { FetcherOptions } from 'hooks/usePaginatedData';
import { useUserSession } from 'hooks/useUserSession';
import { DeviceUseStatementApi } from 'integration';
import type React from 'react';
import { useCallback } from 'react';

import {
  getDataFromResponse,
  patientDeviceUseStatementColumns,
} from './columns';

const deviceUseStatementApi = new DeviceUseStatementApi();

interface PatientDeviceUseStatementListProps {
  patientId: string;
}

export const PatientDeviceUseStatementList: React.FC<
  PatientDeviceUseStatementListProps
> = ({ patientId }) => {
  const deviceUseStatementFetcher = useCallback(
    (options?: FetcherOptions) =>
      deviceUseStatementApi.getDeviceUseStatements({
        subject: patientId,
        pageToken: options?.nextToken,
        ...options,
      }),
    [patientId],
  );

  const session = useUserSession();
  const canUpdate = session.hasAny([GroupSecurity.DeviceUseStatementUpdate]);
  // Feature hidden because functionality does not work.
  const canCalibrate = false;
  const columns = patientDeviceUseStatementColumns(canUpdate, canCalibrate);

  return (
    <PaginatedTable<
      Partial<DeviceAssociationTable>,
      DeviceAssociationGetAllResponse
    >
      cacheKey={`DeviceUseStatement${patientId}`}
      fetcher={deviceUseStatementFetcher}
      columns={columns}
      showHeader={true}
      getDataFromResponse={getDataFromResponse}
      canChangeCount
    />
  );
};
